<template>
  <el-dialog
      :visible.sync="visible"
      title="发票修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="dataRule"
    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="6">
          <el-form-item prop="code" label="发票号：">
            <el-input v-model="dataForm.code" size="mini"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="operateDate" label="开票时间：">
            <el-date-picker v-model="dataForm.operateDate" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="sellerId" label="销售方：" label-width="80px">
            <company v-model="dataForm.sellerId"></company>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="remark" label="备注：" label-width="80px">
            <el-input v-model="dataForm.remark" size="mini"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar" style="margin-bottom: 0;">
        <el-button type="primary" size="mini" @click="showPayDetailSelDialog" v-if="dataForm.sellerId">选择开票明细
        </el-button>
      </div>
      <SweetTable ref="table" v-if="id" :data="dataForm.payDetails" :is-page="false" :height="500"
                  :summaries-column="['totalAmount','count']">
        <el-table-column prop="orderCode" label="订单编号" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="product.code" label="品番号" min-width="90" align="center" header-align="center"
        ></el-table-column>
        <el-table-column prop="product.skuCode" label="SKU" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.name" label="品名" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.color" label="颜色" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.size" label="规格" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.attr1" label="幅宽" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="product.attr2" label="克重" min-width="90" align="center"
                         header-align="center"></el-table-column>

        <el-table-column prop="price" width="160" label="单价" align="center" header-align="center">
          <template v-slot="scope">
            <el-form-item
                :prop="'payDetails.' + scope.$index + '.price'"
                :rules="dataRule.price"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.price"
                  placeholder="单价"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="数量" width="160" align="center" header-align="center">
          <template v-slot="scope">
            <el-form-item
                :prop="'payDetails.' + scope.$index + '.count'"
                :rules="dataRule.count"
                label-width="0"
                style="margin-bottom: 0px"
            >
              <el-input
                  size="mini"
                  v-model="scope.row.count"
                  placeholder="数量"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="80" align="center" header-align="center">
          <template #default="{row,$index}">
            <el-button type="text" @click="removeRow($index)">移除</el-button>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <div class="flex" style="justify-content: space-between;">
        <div style="font-size: 18px;">
          <span>发票金额：</span>
          <span style="color: red;margin-left: 10px;font-size: 20px;">{{ totalAmount }}</span>
        </div>
        <div class="flex">
          <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle()">{{
              $t('confirm')
            }}
          </el-button>
        </div>
      </div>
    </template>
    <PayDetailSelDialog ref="PayDetailSelDialog" @change="payDetailSelChanged"></PayDetailSelDialog>
  </el-dialog>
</template>

<script>
import PayDetailSelDialog from '@/views/modules/erp/pay/PayDetailSelDialog.vue'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  components: { PayDetailSelDialog },
  data () {
    return {
      saving: false,
      dataForm: {},
      visible: false,
      id: '',
      dataRule: {
        code: [
          { required: true, message: '请输入发票号', trigger: 'change' },
        ],
        sellerId: [
          { required: true, message: '请选择销售方', trigger: 'change' },
        ],
        operateDate: [
          { required: true, message: '请填写开票时间', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              }
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数字'))
              }
              callback()
            }, trigger: 'change'
          },
        ],
      }
    }
  },
  computed: {
    totalAmount () {
      if (!this.dataForm || !this.dataForm.payDetails) {
        return 0
      }
      let t = new BigNumber(0)
      this.dataForm.payDetails.forEach(row => {
        let bp = new BigNumber(row.price)
        let bc = new BigNumber(row.count)
        if (bp.isNaN() || bc.isNaN()) {
          return
        }
        t = t.plus(bp.multipliedBy(bc))
      })
      return t.toFixed(3)
    }
  },
  methods: {
    //移除一行
    removeRow ($index) {
      this.dataForm.payDetails.splice($index, 1)
    },
    payDetailSelChanged (data) {
      if (!data || data.length === 0) {
        return
      }
      data.forEach((row, index) => {
        if (this.dataForm.payDetails.find(d => d.sourceId === row.id)) {
          return
        }
        let newRow = {
          id: index,
          count: row.count,
          orderCode: row.agreementCode,
          orderId: row.agreementId,
          price: row.price,
          sourceId: row.id,
          sourceTable: 'ma_factory_store_log',
          product: {
            name: row.productName,
            code: row.productCode,
            skuCode: row.skuCode,
            color: row.color,
            size: row.size,
            attr1: row.attr1,
            attr2: row.attr2,
          }
        }
        this.dataForm.payDetails.push(newRow)
      })
    },
    showPayDetailSelDialog () {
      this.$refs.PayDetailSelDialog.queryForm.senderId = this.dataForm.sellerId
      this.$refs.PayDetailSelDialog.init(this.dataForm.payDetails.map(row => row.sourceId))
    },
    init (id) {
      this.id = id
      this.getInfo()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    getInfo () {
      if (!this.id) {
        return
      }
      this.$api.get(`/erp/pay/${this.id}`).then(res => {
        this.dataForm = {
          ...res,
          payDetails: []
        }
        this.loadDetailList()
        console.log(this.dataForm)
      })
    },
    //读取发票明细
    async loadDetailList () {
      const res = await this.$api.get(`/erp/pay/detail/page`, { params: { pid: this.id, page: 1, limit: 1000000000 } })
      this.$set(this.dataForm, 'payDetails', res.list)
    },
    cancel () {
      this.visible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              ...this.dataForm
            }
            if (this.saving) {
              return
            }
            this.saving = true
            this.$api.post('/erp/pay', postForm).then(res => {
              this.saving = false
              this.$emit('complete')
              this.$c.success(this.$t('prompt.success')).then(() => {
                this.cancel()
              })
            }).catch(() => {
              this.saving = false
            })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  }
}
</script>

<style scoped>

</style>
